import { hexToString, toBytes } from "viem";
import { ZeroAddress } from "ethers";

import type { IServerSignature } from "@dzambalaorg/types-blockchain";
import {
  useAllowance,
  useMetamask,
  useServerSignature,
  useWriteContractWithSimulation,
} from "@dzambalaorg/react-hooks-eth";
import {
  convertDatabaseAssetToChainAsset,
  convertDatabaseAssetToTokenTypeAsset,
  getEthPrice,
} from "@framework/exchange";
import { ListAction, ListActionVariant } from "@framework/styled";
import { AddressType, IContract, ICraft } from "@framework/types";
import ExchangeCraftFacetCraftABI from "@framework/abis/json/ExchangeCraftFacet/craft.json";

interface ICraftButtonProps {
  className?: string;
  craft: ICraft;
  disabled?: boolean;
  variant?: ListActionVariant;
}

export const CraftButton = (props: ICraftButtonProps) => {
  const { className, craft, disabled, variant = ListActionVariant.button } = props;

  const referrer = ZeroAddress;

  const { writeContractAsync } = useWriteContractWithSimulation();

  const { execute: metaFnWithAllowance } = useAllowance(async (sign: IServerSignature, systemContract: IContract) => {
    const items = convertDatabaseAssetToChainAsset(craft.item?.components);
    const price = convertDatabaseAssetToChainAsset(craft.price?.components);
    console.log("metaCraft-items", items);
    return writeContractAsync({
      address: systemContract.address as AddressType,
      abi: ExchangeCraftFacetCraftABI,
      functionName: "craft",
      args: [
        {
          externalId: craft.id,
          expiresAt: sign.expiresAt,
          nonce: toBytes(sign.nonce, { size: 32 }),
          extra: hexToString("0x", { size: 32 }),
          receiver: craft.merchant!.wallet,
          referrer: ZeroAddress,
        },
        items,
        price,
        sign.signature,
      ],
      value: getEthPrice(craft.price),
    });
  });

  const metaFnWithSign = useServerSignature((_values: null, sign: IServerSignature, systemContract: IContract) => {
    const price = convertDatabaseAssetToTokenTypeAsset(craft.price?.components);

    return metaFnWithAllowance(
      {
        contract: systemContract.address,
        assets: price,
      },
      sign,
      systemContract,
    );
  });

  const { execute: metaFn } = useMetamask(() => {
    return metaFnWithSign(
      {
        url: "/recipes/craft/sign",
        method: "POST",
        data: {
          referrer,
          craftId: craft.id,
        },
      },
      null,
    ) as Promise<void>;
  });

  const handleCraft = async () => {
    await metaFn();
  };

  return (
    <ListAction
      onClick={handleCraft}
      message="form.buttons.craft"
      className={className}
      dataTestId="CraftButton"
      disabled={disabled}
      variant={variant}
    />
  );
};
